export function fireKlaviyoEvent(eventName, payload) {
  try {
    switch (eventName) {

      case 'registration': {
        klaviyo.push(['identify', {
          "$email": payload.email,
          "$phone_number": payload?.phone,
          "$first_name": payload?.name || '',
        }]);
        break;
      }
  
      case 'view_product': {
        const item = {
          ProductName: payload.title,
          ProductID: payload.id,
          parent_category: payload.category,
          ImageURL: payload.image,
          Brand: payload.brand,
          Price: payload.prices?.price,
          Currency: payload?.prices?.currency,
        };
  
        klaviyo.push(["track", "Viewed Product", item]);
        break;
      }
  
      case 'add_to_cart': {
        const klaviyoItems = [
          {
            ProductID: payload?.asin,
            ProductName: payload?.title,
            Quantity: 1,
            ItemPrice: payload?.prices?.price,
            ImageURL: payload?.image,
            parent_category: payload?.category,
            Currency: payload.prices?.currency,
          }
        ];
  
        klaviyo.push(["track", "Added to Cart", {
          // "$value": 99.98,
          // AddedItemProductName: "Sample Product",
          // AddedItemProductID: "PROD_1001",
          // AddedItemImageURL: "https://example.com/images/product.jpg",
          // AddedItemURL: "https://example.com/products/prod-1001",
          // AddedItemPrice: 49.99,
          // AddedItemQuantity: 2,
          // ItemNames: ["Sample Product"],
          // CheckoutURL: "https://example.com/checkout",
          Items: klaviyoItems
        }]);
  
        break;
      }
  
      case 'checkout': {
        const klaviyoItems = [
          {
            ProductID: "PROD_1001",
            ProductName: "Sample Product",
            Quantity: 1,
            ItemPrice: 99.99,
            RowTotal: 99.99,
            ProductURL: "https://example.com/products/prod-1001",
            ImageURL: "https://example.com/images/product.jpg",
          }
        ];
  
        klaviyo.push(["track", "Checkout", {
          // "$event_id": "CART_12345",
          // "$value": 99.99,
          currency: "INR",
          // ItemNames: ["Sample Product"],
          // CheckoutURL: "https://example.com/checkout",
          Items: payload
        }]);
  
        break;
      }
  
      // case 'order_placed': {
      //   const klaviyoItems = [
      //     {
      //       ProductID: "PROD_1001",
      //       ProductName: "Sample Product",
      //       Quantity: 1,
      //       ItemPrice: 99.99,
      //       ProductURL: "https://example.com/products/prod-1001",
      //       ImageURL: "https://example.com/images/product.jpg",
      //     }
      //   ];
  
      //   klaviyo.push(["track", "Place Order", {
      //     "$event_id": "CHECKOUT_98765",
      //     "$value": 99.99,
      //     OrderId: "ORDER_55555",
      //     Categories: ["Electronics"],
      //     ItemNames: ["Sample Product"],
      //     DiscountCode: "WELCOME10",
      //     DiscountValue: 10.00,
      //     Items: klaviyoItems
      //   }]);
  
      //   break;
      // }
  
      default:
        console.warn(`Unhandled Klaviyo event: ${eventName}`);
    }

  } catch (error) {
    console.log("something went wrong for klaviyo");
  }

  }